import React, { useState } from "react";
import { useEffect } from "react";
import { OrdinationsAndCountriesService } from "../services/ordinationsAndCountries";
export const OrdinationsAndCountriesContext = React.createContext({});

export const OrdinationsAndCountriesContextProvider = (props) => {
  const [countries, setCountries] = useState();
  const [ordinations, setOrdinations] = useState();
  const [ordinationId, setOrdinationId] = useState();

  const getCountries = async () => {
    const countriesObj = await OrdinationsAndCountriesService.getCountries();
    setCountries(countriesObj);
  };

  const getOrdinations = async () => {
    const ordinationsObj =
      await OrdinationsAndCountriesService.getOrdinations();
      setOrdinations(ordinationsObj);
  };

  const getSelectedOrdinationId = async () => {
    try{
    const selectedOrdinationId =
      await OrdinationsAndCountriesService.getSelectedOrdinationId();
      setOrdinationId(selectedOrdinationId);
      
    }catch{
      
    }
  };
  const setSelectedOrdinationId = async (id = ordinationId) => {
    try {
        await OrdinationsAndCountriesService.selectOrdination(id);
        setOrdinationId(id);
    } catch (e) {
      console.log(e);
    }
  };

  const refresh = () => {
    getCountries();
    getOrdinations();
    getSelectedOrdinationId();
  };

  useEffect(() => {
    getCountries();
    getOrdinations();
    getSelectedOrdinationId();
  }, []);

  return (
    <OrdinationsAndCountriesContext.Provider
      value={{ countries, ordinations, ordinationId, setOrdinationId, setSelectedOrdinationId,refresh }}
    >
      {props.children}
    </OrdinationsAndCountriesContext.Provider>
  );
};
